class RootStore {
  constructor(uiStores = {}, domainStores = {}, addToStore = () => undefined) {
    this.uiState = uiStores;
    this.domain = domainStores;
    this.addToStore = addToStore;
  }

  addUiStore(storeName, storeInstance) {
    this.uiState = {
      ...this.uiState,
      [storeName]: storeInstance,
    };
  }

  addDomainStore(storeName, storeInstance) {
    this.domain = {
      ...this.domain,
      [storeName]: storeInstance,
    };
  }

  addToStore(params) {
    // Root Store does not know the storage data structure at this point
    // Thats why we need the function sent from consuming application
    this.addToStore(params);
  }

  async clearStoredData() {
    await Promise.all([
      Object.entries(this.uiState).map(async ([, obj]) => obj.clearStore()),
      Object.entries(this.domain).map(async ([, obj]) => obj.clearStore()),
    ]);
  }
}

export default RootStore;
